class NavScrolled {
	constructor() {
		this.nav = document.querySelector('.nav-scrolled');

		if (!this.nav) return;

		this.initNavScroll();
	}


	initNavScroll() {
		this.activeAfter = 300;
		// the point the scroll starts from (in px)
		this.lastScrollY = 0;
		// how far to scroll (in px) before triggering
		this.delta = 20;

		// Add event listener & debounce so not constantly checking for scroll
		let didScroll = false;
		window.addEventListener("scroll", function(e){
			didScroll = true;
		});

		setInterval(
			() => {
				if (didScroll) {
					this.scrolled();
					didScroll = false;
				}
			}, 250);
	}

	scrolled() {
		let sy = window.scrollY;
		// only trigger if scrolled more than delta
		if (Math.abs(this.lastScrollY - sy) > this.delta) {
			if (sy < this.activeAfter) {
				this.nav.classList.add("nav-up");
			}

			// scroll down -> hide nav bar
			else if (sy > this.lastScrollY && sy > this.activeAfter) {
				this.nav.classList.add("nav-up");
			}

			// scroll up -> show nav bar
			else if (sy > this.activeAfter && sy < this.lastScrollY) {
				this.nav.classList.remove("nav-up");
			}
			// update current scroll point
			this.lastScrollY = sy;
		}
	}
}